import CrudCustom from '../../../libs/custom/CrudCustom';

let FixedAsetService = new CrudCustom('/kategori-asets');
export default FixedAsetService;
